import { FIELD_M } from "../../helpers";
export var MIN_WIDTH_TAG_INPUT = FIELD_M;
export var DEFAULT_TEXTS = {
    placeholderWithSuggest: 'Enter tag or choose from the list...',
    placeholderWithoutSuggest: 'Enter tag...'
};
//# sourceMappingURL=helpers.js.map